import classNames from 'classnames';
import { format, toZonedTime } from 'date-fns-tz';
import { twMerge } from 'tailwind-merge';
import moment from 'moment';

// import crypto from 'crypto';

export function cn(...inputs: classNames.ArgumentArray) {
    return twMerge(classNames(inputs));
}

// 期間 default 用の ISO 日付ヘルパー (= dashboard / event tracking で共通利用)
export const todayIso = () => new Date().toISOString().slice(0, 10);
export const daysAgoIso = (days: number) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return d.toISOString().slice(0, 10);
};

export function getAvatarFallbackName(fullname?: string) {
    if (!fullname) return '';
    const names = fullname.trim().split(' ');

    if (names.length === 1) {
        // Trường hợp chỉ có một từ
        return `${names[0].charAt(0).toUpperCase()}${names[0].charAt(1).toUpperCase()}`;
    } else if (names.length > 1) {
        // Lấy ký tự đầu tiên của tên và họ
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }

    return '';
}

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

export const convertDate = (time) => {
    if (!time) {
        return null;
    }

    const formattedDate = moment(time);

    return {
        date: formattedDate.format('YYYY/MM/DD'),
        time: formattedDate.format('HH:mm:ss'),
        ampm: formattedDate.format('A')
    };
};

export const convertFileSizeToMb = (bytes: number, decimalPlaces: number = 2): number => {
    if (bytes <= 0) return 0;
    const mb = bytes / (1024 * 1024);
    return parseFloat(mb.toFixed(decimalPlaces));
};

export const getGmailPrefix = (email) => {
    if (email.includes('@')) {
        return email.split('@')[0];
    }
    return email;
};

export function generateCouponCode() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let couponCode = '';
    const timestamp = Date.now();

    for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        couponCode += chars[randomIndex];
    }

    return `${timestamp}${couponCode}`;
}
